import React from 'react';
import {View} from 'react-native';
import CCText from '@/Atoms/CCText';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import ChessModalShell, {ChessModalAccent} from './ChessModalShell';
import PillButton from './PillButton';

export type ChessConfirmBullet = {icon: string; text: string};

// Chess-branded confirmation dialog. Keeps ConfirmationModal's prop
// signature (open / header / bodyTxt / handleClose / handleConfirmation)
// so existing call sites migrate mechanically, and adds the shell's
// theming knobs on top.
function ChessConfirm({
  open,
  header = 'Confirm',
  bodyTxt,
  handleClose,
  handleConfirmation,
  piece = 'chess-pawn',
  pieceRotation,
  ghostPiece,
  accent = 'teal',
  bullets,
  confirmLabel = 'Confirm',
  confirmIcon,
  cancelLabel = 'Cancel',
  compact,
}: {
  open: boolean;
  header?: string;
  bodyTxt?: string;
  handleClose: () => void;
  handleConfirmation: () => void;
  piece?: string;
  pieceRotation?: number;
  ghostPiece?: string;
  accent?: ChessModalAccent;
  bullets?: ChessConfirmBullet[];
  confirmLabel?: string;
  confirmIcon?: string;
  cancelLabel?: string;
  compact?: boolean;
}) {
  return (
    <ChessModalShell
      visible={open}
      onClose={handleClose}
      title={header}
      subtitle={bodyTxt}
      piece={piece}
      pieceRotation={pieceRotation}
      ghostPiece={ghostPiece}
      accent={accent}
      compact={compact ?? !bullets?.length}
      showClose={false}
      footer={
        <>
          <PillButton
            label={cancelLabel}
            variant="outline"
            onPress={handleClose}
          />
          <PillButton
            label={confirmLabel}
            icon={confirmIcon}
            variant={accent === 'red' ? 'danger' : 'primary'}
            onPress={() => {
              handleConfirmation?.();
              handleClose();
            }}
          />
        </>
      }>
      {bullets?.length ? (
        <View
          style={{
            backgroundColor: '#FFFFFF',
            borderRadius: 12,
            borderWidth: 1,
            borderColor: 'rgba(77,63,55,0.10)',
            padding: 16,
            gap: 10,
          }}>
          {bullets.map((item, i) => (
            <View
              key={i}
              style={{flexDirection: 'row', alignItems: 'center', gap: 10}}>
              <View
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 8,
                  backgroundColor: 'rgba(250,207,71,0.12)',
                  borderWidth: 1,
                  borderColor: 'rgba(250,207,71,0.25)',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}>
                <MaterialCommunityIcons
                  name={item.icon}
                  size={14}
                  color="#2A1F1A"
                />
              </View>
              <CCText
                fontSize={12}
                color="#262322"
                style={{flex: 1, lineHeight: 17}}>
                {item.text}
              </CCText>
            </View>
          ))}
        </View>
      ) : null}
    </ChessModalShell>
  );
}

export default ChessConfirm;
